function BitArray(value, size){
    var arr;
    if(Array.isArray(value)){
        arr = value;
    }else{
        arr = [];
        for(var i=(size-1); i>=0; i--){
            arr.push((value & 1<<i) !== 0 ? 1 : 0);
        }
    }

    this.length = arr.length;
    this.toArray = function(){return arr};

    this.toOctetArray = function() {
        // Fill up arr to nearest byte
        var byte_arr = this.toArray().slice(0);
        var missingBits = (8 - (byte_arr.length % 8)) % 8;
        for (var i = 0; i < missingBits; i++) {
            byte_arr.push(0)
        }
        // Compute OctetArray
        var octetArray = [];
        for (i = 0; i < byte_arr.length; i += 8) {
            var val = 0 | byte_arr[i] << 7
                | byte_arr[i + 1] << 6
                | byte_arr[i + 2] << 5
                | byte_arr[i + 3] << 4
                | byte_arr[i + 4] << 3
                | byte_arr[i + 5] << 2
                | byte_arr[i + 6] << 1
                | byte_arr[i + 7];
            octetArray.push(val);
        }
        return octetArray;
    };

    this.toHextetArray = function() {
        // Fill up arr to nearest byte
        var byte_arr = this.toArray().slice(0);
        var missingBits = (16 - (byte_arr.length % 16)) % 16;
        for (var i = 0; i < missingBits; i++) {
            byte_arr.push(0)
        }
        // Compute HextetArray
        var hextetArray = [];
        for (i = 0; i < byte_arr.length; i += 16) {
            var val = 0 | byte_arr[i] << 15
                | byte_arr[i + 1] << 14
                | byte_arr[i + 2] << 13
                | byte_arr[i + 3] << 12
                | byte_arr[i + 4] << 11
                | byte_arr[i + 5] << 10
                | byte_arr[i + 6] << 9
                | byte_arr[i + 7] << 8
                | byte_arr[i + 8] << 7
                | byte_arr[i + 9] << 6
                | byte_arr[i + 10] << 5
                | byte_arr[i + 11] << 4
                | byte_arr[i + 12] << 3
                | byte_arr[i + 13] << 2
                | byte_arr[i + 14] << 1
                | byte_arr[i + 15];
            hextetArray.push(val);
        }
        return hextetArray;
    };


    this.toBuffer = function(){
        return new Buffer(this.toOctetArray());
    }
}

BitArray.concat = function(){
    var args;
    if(Array.isArray(arguments['0'])){
        args = arguments['0'];
    }else{
        args = Array.prototype.slice.call(arguments);
    }
    return new BitArray(Array.prototype.concat.apply([], args.map(function(ba){return ba.toArray()})));
};

module.exports = BitArray;



//////////////////
// WEBPACK FOOTER
// ./srv/common/bitArray.js
// module id = 1013
// module chunks = 7